import { useLocationsContext } from '@/src/contexts/LocationsContext'
import { ALL_LOCATIONS } from '@/src/contexts/LocationsContext'
import { useLoadPlanningCurrentLocation } from '@/src/features/procurement-and-markets/load-planning/contexts/LoadPlanningCurrentLocationContext'
import {
  useLoadPlanningAdjustments,
  useLoadedStrategyMetadata,
} from '@/src/features/procurement-and-markets/load-planning/hooks/LoadPlanning.hooks'
import { mapAdjustmentsToRows } from '@/src/features/procurement-and-markets/load-planning/load-planning-adjustments/table/adjustmentTable.utils'
import { Box, Spinner } from '@chakra-ui/react'
import { FlexCol } from '@components'

import { BaseText } from '@/src/components/BaseText'
import { EmptyReportsIcon } from '@/src/features/analytics/icons'
import { mapToEnergyTypeDto } from '@/src/features/procurement-and-markets/details/types/adjustment.utils'
import { LoadPlanningAdjustmentTable } from '@/src/features/procurement-and-markets/load-planning/load-planning-adjustments/table/LoadPlanningAdjustment.table'
import { MeasureCandidateTable } from '@/src/features/procurement-and-markets/load-planning/load-planning-adjustments/table/MeasureCandidate.table'
import { useTranslation } from 'react-i18next'

export const LoadPlanningAdjustmentTablePage = () => {
  const { t } = useTranslation()
  const { data: strategy } = useLoadedStrategyMetadata()
  const { companyPgId: companyId } = useLocationsContext()
  const { locationId } = useLoadPlanningCurrentLocation()
  const { data: adjustments } = useLoadPlanningAdjustments({
    companyId,
    locationId: locationId !== ALL_LOCATIONS ? locationId : undefined,
    energyType: mapToEnergyTypeDto(strategy?.energyType),
    year: strategy?.year ? Number(strategy?.year) : undefined,
  })

  if (!adjustments)
    return (
      <FlexCol justifyContent='center' alignItems='center' padding={8} minHeight={'540px'} textAlign={'center'}>
        <Spinner />
      </FlexCol>
    )

  const rows = mapAdjustmentsToRows(adjustments)

  if (rows.length === 0 && adjustments.measureSimulationCandidates.length === 0) {
    return (
      <FlexCol justifyContent='center' alignItems='center' padding={8} minHeight={'540px'} textAlign={'center'}>
        <EmptyReportsIcon />
        <Box width='80%'>
          <BaseText>{t('components.procurement.forecasting.adjustment_table.empty_state_text')}</BaseText>
        </Box>
      </FlexCol>
    )
  }

  return (
    <Box px={'2px'}>
      <Box overflowX='auto'>
        {!!rows.length && (
          <>
            <BaseText fontWeight='bold' marginBottom={'12px'}>
              {t('components.procurement.forecasting.adjustment_table.adjustments_heading')}
            </BaseText>
            <LoadPlanningAdjustmentTable rows={rows} />
          </>
        )}
        <Box marginBottom={'12px'} />
        {!!adjustments.measureSimulationCandidates.length && (
          <>
            <BaseText fontWeight='bold' marginBottom={'12px'}>
              {t('components.procurement.forecasting.adjustment_table.measure_simulation_candidates_heading')}
            </BaseText>
            <MeasureCandidateTable rows={adjustments.measureSimulationCandidates} />
          </>
        )}
      </Box>
    </Box>
  )
}
